import { Link } from 'react-router'
import { FormattedMessage } from 'react-intl'

import shields from '@static/images/dashboards/dashboard-unavailable.png'
import './DashboardUnavailable.css'

export default function DashboardUnavailable() {
  return (
    <div id="dashboard-unavailable">
      <div className="wrapper">
        <img src={shields} alt="" />
        <h2>
          <FormattedMessage id="dashboard.unavailable.title" />
        </h2>
        <p>
          <FormattedMessage id="dashboard.unavailable.text" />
        </p>
        <div className="buttons">
          <Link to="/dashboards?scope=public" className="cta-button button">
            <span className="icon icon-angle-left" />
            <span>
              <FormattedMessage id="dashboard.unavailable.button" />
            </span>
          </Link>
        </div>
      </div>
    </div>
  )
}
